import { apiAuthRoot, apiV2AuthRoot } from '@/api/instances.js'
import profile from '@/api/services/profile.js'
import auth from '@/api/services/auth.js'
import auth2 from '@/api/services/auth2'
import cabinet from '@/api/services/cabinet.js'

export const api = {
  profile: profile(apiV2AuthRoot),
  auth: auth(apiV2AuthRoot),
  auth2: auth2(apiAuthRoot),
  cabinet: cabinet(apiV2AuthRoot),
}
